import React, { useState } from 'react';
import { Box, Grid, Button, Divider, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { dataConstants } from '../../constants';
import useAuth from '../../hook/auth';

const PricingAdBanner = ({ pricePlans, bannerType, adTitle, adDesc }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const plan = "Premium";
  const plans = pricePlans ? pricePlans : (process.env.NODE_ENV !== 'production' ? dataConstants.DEVPLANS : dataConstants.PRODPLANS);
  const premiumPlan = plans && plans.length > 0 ? plans?.find(d => d.plan.toLowerCase() === plan.toLowerCase()) : null;
  const [currency_type, set_currency_type] = useState('usd');
  const monthlyPrice = premiumPlan && currency_type === "inr" ? premiumPlan?.im.toString() : premiumPlan?.m.toString();

  const auth = useAuth();
  const { user } = auth || {}
  const { reloadUserInfo } = user || {}
  const bots = ["googlebot", "bingbot", "slurp", "duckduckbot", "yandexbot", "facebot", "applebot"]
  const isBot = typeof window === "undefined" ? false : bots.some(el => navigator.userAgent.toLowerCase().includes(el))
  const isPremium = isBot ? true : (reloadUserInfo?.customAttributes && (JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PREMIUM" || JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PROFESSIONAL") ? true : false);

  return (
    <>
      {isPremium ? null :
        <Grid size={{ md: 12, xs: 12, sm: 12 }}>
          <Box component="div" className="ad-wrapperr"
            sx={{
              backgroundImage: "url(/images/components/banner/back5.jpeg)", borderRadius: '12px',
              backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', mx: 0,
            }}
          >
            <Box component="div" className="row sum-r ad"
              sx={{
                backgroundColor: 'rgba(17, 25, 40, 0.45)', borderRadius: '12px',
                backdropFilter: 'blur(20px) saturate(186%)',
                '-webkit-backdrop-filter': 'blur(20px) saturate(186%)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                // boxShadow: '0 0 10px 1px rgba(0, 0, 0, 0.25)',
              }}>
              <Box component="div" sx={{ p: 3, display: "flex", alignItems: 'center', justifyContent: 'space-between', flexWrap: { md: 'nowrap', sm: 'wrap', xs: 'wrap' } }}>
                <div>
                  <Typography variant="h6" component="div" sx={{ color: '#fff', fontWeight: 500 }}>{adTitle}</Typography>
                  <Typography variant="body1" component="div" sx={{ mt: 1.5, color: '#c0c0c0', fontSize: '.97rem', }}>
                    {adDesc}
                  </Typography>
                </div>
                <Typography variant="body1" component="div" sx={{ mx: { md: 10, sm: 3, xs: 0 }, display: { md: 'block', sm: 'none', xs: 'none' } }} />
                <Button href={`/pricing?ref=${bannerType ?? 'inapp-ad-banner'}`} variant="contained"
                  sx={{
                    fontSize: '.875rem', fontWeight: 600, textTransform: 'none',
                    ml: { md: 'auto', sm: 0, xs: 0 }, bgcolor: '#f7f7f7', color: '#000', '&:hover': { bgcolor: '#fff', color: 'primary.main' },
                    textWrap: "nowrap", px: 4, mt: { md: 0, sm: 3, xs: 4 }
                  }}
                >
                  {/* Try For Just $1.99 */}
                  Buy Subscription
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>}
    </>
  );
};

export default React.memo(PricingAdBanner);
